import { createInitialPlanDraft, serializePlanDraftForSave } from "./nutritionPlanLogic";

export function normalizeNutritionPlanExportName(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function buildCoachNutritionPlanLibraryExportDraft({
  sourcePlan,
  exportPlanId,
  exportName,
} = {}) {
  const normalizedExportName = normalizeNutritionPlanExportName(exportName);
  const normalizedExportPlanId = String(exportPlanId ?? "").trim().toLowerCase();

  if (!normalizedExportName || !normalizedExportPlanId) {
    return null;
  }

  const sourceDraft = createInitialPlanDraft(sourcePlan ?? {});

  return serializePlanDraftForSave({
    ...sourceDraft,
    id: normalizedExportPlanId,
    name: normalizedExportName,
  });
}
